'use client';

interface QuizTextInputProps {
  question: string;
  instruction?: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  maxLength?: number;
  type?: 'text' | 'email';
}

export function QuizTextInput({
  question,
  instruction,
  value,
  onChange,
  placeholder,
  maxLength,
  type = 'text',
}: QuizTextInputProps) {
  return (
    <div className="w-full max-w-2xl mx-auto px-4 py-8">
      <div className="text-center mb-8">
        <h1 className="text-3xl md:text-4xl font-bold text-white mb-3">
          {question}
        </h1>
        {instruction && (
          <p className="text-gray-400 text-sm">{instruction}</p>
        )}
      </div>

      <div className="space-y-4">
        {type === 'email' ? (
          <input
            type="email"
            value={value}
            onChange={(e) => onChange(e.target.value)}
            placeholder={placeholder}
            maxLength={maxLength}
            className="w-full p-4 rounded-xl bg-gray-800/50 border-2 border-gray-700 text-white placeholder-gray-500 focus:border-blue-600 focus:outline-none transition-colors"
          />
        ) : (
          <textarea
            value={value}
            onChange={(e) => onChange(e.target.value)}
            placeholder={placeholder}
            maxLength={maxLength}
            rows={4}
            className="w-full p-4 rounded-xl bg-gray-800/50 border-2 border-gray-700 text-white placeholder-gray-500 focus:border-blue-600 focus:outline-none transition-colors resize-none"
          />
        )}

        {maxLength && (
          <div className="text-right text-sm text-gray-500">
            {value.length} / {maxLength}
          </div>
        )}

        <div className="text-xs text-gray-500 text-center mt-4">
          🔒 Your personal data is safe with us. We don't send spam or share email addresses with third parties.
        </div>
      </div>
    </div>
  );
}
